import { render, staticRenderFns } from "./DocumentRecord.vue?vue&type=template&id=550e29ac&"
import script from "./DocumentRecord.vue?vue&type=script&lang=js&"
export * from "./DocumentRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports